export default {
  mobile: '480px',
  mobileLandscape: '568px',
  tablet: '768px',
  tabletMid: '991px',
  tabletLandscape: '1024px',
  desktop: '1344px',
}
